import { render, staticRenderFns } from "./PanelIcon.vue?vue&type=template&id=c523ee5e&"
import script from "./PanelIcon.vue?vue&type=script&lang=js&"
export * from "./PanelIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports